import $ from 'jquery'
import jstz from 'jstimezonedetect'
import { viewModalEvent } from 'application/ga_view_modal_event'
import { trim } from 'lodash'

const $form = $('#header-sign-up-form')
const $submitFormButton = $('button[type="submit"]', $form)
const $link = $("a[data-open='create-account-overlay']")
const $signInLink = $('.popup-sign-in-link')
const signInUrl = $signInLink.attr('href')
const $createAccountForm = $('#header-sign-up-form');

let isViaBanner = false;

$(document).foundation()

$link.off('click.signup').on('click.signup', () => {
  if ($(this).data('banner')) {
    isViaBanner = true
    let url  = SOPHIA.Routes.new_user_sessions_path({ redirect: SOPHIA.Routes.membership_profile_path() })
    $signInLink.attr('href', url)
  } else {
    $signInLink.attr('href', signInUrl)
    isViaBanner = false
  }

  const modal = '#create-account-overlay[data-reveal]'

  $(document).on('open.zf.reveal', modal, () => {
    viewModalEvent({})
    SOPHIA.formGA($createAccountForm, 'form_view');
  });

  $(document).on('closed.zf.reveal', modal, () => {
    SOPHIA.clickModalCloseForGA(false, modal)

    $(document).off('closed.zf.reveal', modal).off('open.zf.reveal', modal)
  })

  $(document).on('closeme.zf.reveal', '#create-account-overlay[data-reveal]', () => {
    $('.form-field__errors').remove()
    $('.form-field__input', modal).val('')
    $('.form-field.field_with_errors', modal).removeClass('field_with_errors')
    $('.password-hint-list .icon-checkmark', modal).removeClass('checked')
    $('.form-field', modal).removeClass('form-field--is-filled')
  })
});

$form.find('.user_time_zone').val(jstz.determine().name)
validateButton($form)

$("input[type='email'], input[type='password'], input[type='text']", $form).on('keyup', () => {
  validateButton($form)
});

$("input[type='email'], input[type='password'], input[type='text']", $form).on('focus', () => {
  legalAgreementShow($form)
});

$submitFormButton.on('click', (e) => {
  e.preventDefault()

  const formName = $form.data('formName'),
        formType = $form.data('formType') || $form.data('formName'),
        formPage = trim($form.data('formPage')),
        formPageCategory = $form.data('formPageCategory'),
        formCourseName = $form.data('formCourseName'),
        formPartner = $form.data('formPartner'),
        formPageType = $form.data('formPageType'),
        formPageTitle = trim($form.data('formPageTitle')),
        params = $form.serializeArray()

  params.push({
    name: 'stat_event',
    value: true
  }, {
    name: 'stat[form_name]',
    value: formName
  }, {
    name: 'stat[form_type]',
    value: formType
  }, {
    name: 'stat[form_page]',
    value: formPage
  })

  if (formCourseName) params.push({ name: 'stat[form_course_name]', value: formCourseName });
  if (formPageCategory) params.push({ name: 'stat[form_page_category]', value: formPageCategory });
  if (formPartner) params.push({ name: 'stat[form_partner]', value: formPartner});
  if (formPageTitle) params.push({ name: 'stat[form_page_title]', value: formPageTitle });
  if (formPageType) params.push({ name: 'stat[form_page_type]', value: formPageType });

  const data = {
    url: $form.attr('action'),
    type: $form.attr('method'),
    dataType: 'json',
    data: params
  };

  const callbacks = {
    afterSuccess: (response) => {
      if (response.errors) {
        const errors = response.errors

        // fields errors
        $.each($('input[type="text"], input[type="password"], input[type="email"]', $form), (index, field) => {
          const $field = $(field)
          const $fieldWrapper = $field.parents('.form-field')
          const fieldName = $field.attr('name')
          const errorsArray = Object.keys(errors).map((key) => ({name: key, error: errors[key]}))

          $.each(errorsArray, (index, error) => {
            let errorName = 'user[' + error.name + ']'
            let errorDescription = error.error
            let errorMessage = '<div class="form-field__errors">' + errorDescription[0] + '</div>';
            if (errorName == fieldName) {
              $('.form-field__errors', $fieldWrapper).remove()
              $fieldWrapper.addClass('field_with_errors').append(errorMessage);
            }
          })

          $field.on('keyup', () => {
              $fieldWrapper.removeClass('field_with_errors')
              $('.form-field__errors', $fieldWrapper).remove()
          })
        })
      } else {
        if (isViaBanner === true) {
          window.location = SOPHIA.Routes.membership_profile_path()
        } else {
          window.location.reload()
        }
      }
    }
  };

  SOPHIA.sendXHR(data, callbacks);
})

function validateButton($form) {
  let isValid = true
  const $button = $form.find('.create-account-overlay-button'),
        $fields = $("input[type='email'], input[type='password'], input[type='text']", $form);

  $fields.each((i, e) => {
     const $this = $(e);
     if ($this.val() == "") {
       isValid = false;
     }
  });

  if (isValid) {
    $button.removeClass('disabled-class').prop('disabled', false);
  } else {
    $button.addClass('disabled-class').prop('disabled', true);
  }
}

function legalAgreementShow($form) {
  const inputs = []

  $('.form-field__input:not(.is-additional)', $form).each((i, e) => {
    if ($(e).val() == '') {
      inputs.push($(e));
    }
  });

  if (inputs.length <= 1) {
    $('.hidden-field', $form).show( "slow", () => {
      $('.hidden-field', $form).removeClass('hidden-field').fadeTo( "fast" , 1 );
    });
  }
}
